import { ReactNode } from 'react';

import { IPermission } from '@/services/types/apiManagement';
export interface IPermissionRecord {
  id: number;
  type: string;
  value: string;
  businessType: ReactNode;
  permissionName: ReactNode;
  writePermission: ReactNode;
  readPermission: string;
  hide?: boolean;
  disabled?: boolean;
  defaultChecked?: boolean;
}
// 分别对应子/母账号的值
/**
 * 大写字母开头的母账号权限，小写字母开头的是子账号权限项
 */
export const permissionMap: any = {
  1: [{ ContractTrade: 'Order' }, { contractTrade: 'API_PERMISSION_ORDER' }],
  2: [
    { ContractTrade: 'Position' },
    { contractTrade: 'API_PERMISSION_POSITION' },
  ],
  4: [{ Options: 'OptionsTrade' }, { options: 'API_PERMISSION_OPTIONS_TRADE' }],
  5: [{ Spot: 'SpotTrade' }, { spot: 'API_PERMISSION_SPOT_TRADE' }],
  6: [
    { CopyTrading: 'CopyTrading' },
    { copyTrading: 'API_PERMISSION_COPY_TRADING' },
  ],
  7: [
    { Wallet: 'AccountTransfer' },
    { wallet: 'API_PERMISSION_ACCOUNT_TRANSFER' },
  ],
  // 子账号没有母子账号划转权限，因此屏蔽
  8: [
    { Wallet: 'SubMemberTransfer' },
    { wallet: 'API_PERMISSION_SUBMEMBER_TRANSFER' },
  ],
  9: [{ Wallet: 'Withdraw' }],
  10: [
    { Derivatives: 'DerivativesTrade' },
    { derivatives: 'API_PERMISSION_DERIVATIVES_TRADE' },
  ],
  11: [
    { Exchange: 'ExchangeHistory' },
    { exchange: 'API_PERMISSION_EXCHANGE_HISTORY' },
  ],
  12: [
    { BlockTrade: 'BlockTrade' },
    { blockTrade: 'API_PERMISSION_BLOCK_TRADE' },
  ],
  13: [{ NFT: 'NFTQueryProductList' }],
  14: [
    { Wallet: 'SubMemberTransferList' },
    { wallet: 'API_PERMISSION_SUBMEMBER_TRANSFER_LIST' },
  ],
  15: [
    {
      Affiliate: 'Affiliate',
    },
  ],
};

// 查询某一type的index以及value
const getRealPermissionKey = (
  isSubAccount: boolean,
  type: string,
  permission: string[],
) => {
  const index = isSubAccount ? 1 : 0;
  const realKey: number[] = [];
  Object.keys(permissionMap).forEach((key: string) => {
    const currentPermission = permissionMap[key] || [];
    const realPermission = currentPermission[index] || {};
    if (
      currentPermission?.length >= index + 1 &&
      permission.includes(realPermission[type])
    ) {
      realKey.push(Number(key));
    }
  });
  return realKey;
};
export const permissionMapKey = (
  permission: IPermission = {} as IPermission,
  isSubAccount: boolean,
) => {
  const permissionKey: number[] = [];
  Object.entries(permission).forEach(
    ([type, permission]: [key: string, permission: string[]]) => {
      permissionKey.push(
        ...getRealPermissionKey(isSubAccount, type, permission || []),
      );
    },
  );
  return permissionKey;
};

export const calPermission = (keys: React.Key[], isSubAccount: boolean) => {
  const permissions: any = {};
  const index = isSubAccount ? 1 : 0;

  keys.forEach((attr: React.Key) => {
    const keyPermission = permissionMap[attr][index] || {};
    if (Object.keys(keyPermission)) {
      const [key, value] = Object.entries(keyPermission)[0];
      if (!permissions[key]) {
        permissions[key] = [];
      }
      permissions[key]?.push(value);
    }
  });
  return permissions;
};

export const mergeCells = (dataSource: any[], key = 'type') => {
  const rowSpanArr = [];
  //保存上一个key
  let x = '';
  // 相同key出现的次数
  let count = 0;
  // 该key第一次出现的位置
  let startIndex = 0;

  for (let i = 0; i < dataSource.length; i++) {
    //合并key列
    const val = dataSource[i][key];
    if (i == 0) {
      x = val;
      count = 1;
      rowSpanArr[0] = 1;
    } else {
      if (val == x) {
        ++count;
        rowSpanArr[startIndex] = count;
        rowSpanArr[i] = 0;
      } else {
        count = 1;
        x = val;
        startIndex = i;
        rowSpanArr[i] = 1;
      }
    }
  }
  return rowSpanArr;
};
